import z from 'zod';
import { STATUS_SNAPSHOT_FAMILIES } from '../database/document-status-snapshot.schema.js';
/**
 * DR-3275 — nudge for the per-document status contract. Deliberately carries ids only,
 * no rows: the snapshot store is authoritative and serves full history through
 * `GET /api/status-snapshots?cursor=<nextCursor>`, so a dropped or out-of-order nudge costs
 * a consumer nothing but latency. Keeping the payload tiny also means a document with
 * thousands of AD rows never pushes a multi-megabyte body through the webhook queue.
 *
 * Emitted only after a write that CHANGED data (new generation), so a re-extraction that
 * reproduces the identical rows is silent.
 *
 * Carries no cursor: the feed is keyset-paged on the row's own commit-ordered `(updatedAt, id)`,
 * and a consumer resumes from the `nextCursor` it last stored, never from anything a nudge
 * hands it. A nudge that arrives before the row clears the feed's lag window would otherwise
 * tempt a consumer into a cursor that skips its neighbours.
 */
export const statusSnapshotReadyWebhookSchema = z.looseObject({
    type: z.literal('status-snapshot-ready'),
    projectId: z.string(),
    documentId: z.string(),
    reconstructedDocumentId: z.string(),
    family: z.enum(STATUS_SNAPSHOT_FAMILIES),
    generation: z.number(),
});
//# sourceMappingURL=status-snapshot-ready.webhook.js.map